import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.776 4.193a.7.7 0 0 0-.22-.14.67.67 0 0 0-.507 0 .7.7 0 0 0-.22.14L1.496 5.527a.67.67 0 1 0 .947.946l.193-.2v5.06a.667.667 0 1 0 1.333 0v-5.06l.194.2a.666.666 0 0 0 1.092-.217.67.67 0 0 0-.146-.73zm3.527 1.14h6.666a.666.666 0 1 0 0-1.333H7.303a.667.667 0 0 0 0 1.333m6.666 5.334H7.303a.667.667 0 1 0 0 1.333h6.666a.666.666 0 1 0 0-1.333m0-3.334H7.303a.667.667 0 0 0 0 1.334h6.666a.666.666 0 1 0 0-1.334"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })